import { render, staticRenderFns } from "./CallOverlay.vue?vue&type=template&id=715b9426&scoped=true"
import script from "./CallOverlay.vue?vue&type=script&lang=js"
export * from "./CallOverlay.vue?vue&type=script&lang=js"
import style0 from "./CallOverlay.vue?vue&type=style&index=0&id=715b9426&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715b9426",
  null
  
)

export default component.exports